import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useState, useEffect, useRef } from 'react';
import Popup from '../popup';
import DefaultTheme from './theme';
import Input from './input';
import MultiInput from './multi-input';
import DefaultList from './list';
import DefaultItem from './item';
import InputMolecule from '../input';
import FormElement from '../form-element';
export var SelectTheme = DefaultTheme;
/*::
import type { Node, ComponentType } from 'react';
import type { ItemProps } from './item';
import type { SelectThemeType } from './theme';

export type OptionType = {|
  value: string,
  label: string,
|};
export type ValueType = ?OptionType | Array<?OptionType>;

export type Props = {|
  options: Array<OptionType>,
  value?: ValueType,
  multiple?: boolean,
  initialOthersOption?: OptionType,
  othersLabel?: string,
  onChange?: (value: ?ValueType) => void,
  onFocus?: (e: FocusEvent) => void;
  onBlur?: (e: FocusEvent) => void;
  error?: boolean,
  disabled?: boolean,
  disableOptionClearing?: boolean,
  theme?: SelectThemeType,
  disableLookup?: boolean,
  Item?: ComponentType<ItemProps>,
  'data-test'?: string;
  rest?: any,
|};

  type ValueState = {|
    val: ?ValueType;
  |}

  type SetValueState = ((ValueState => ValueState) | ValueState) => void;
*/

var ENTER = 13;
var UP = 38;
var DOWN = 40;
var BACKSPACE = 8;
var ESCAPE = 27;

var Select = function Select(_ref
/*: Props */
) {
  var options = _ref.options,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      _ref$initialOthersOpt = _ref.initialOthersOption,
      initialOthersOption = _ref$initialOthersOpt === void 0 ? null : _ref$initialOthersOpt,
      _ref$othersLabel = _ref.othersLabel,
      othersLabel = _ref$othersLabel === void 0 ? 'Enter other options' : _ref$othersLabel,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return undefined;
  } : _ref$onChange,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$disableOptionCle = _ref.disableOptionClearing,
      disableOptionClearing = _ref$disableOptionCle === void 0 ? false : _ref$disableOptionCle,
      _ref$disableLookup = _ref.disableLookup,
      disableLookup = _ref$disableLookup === void 0 ? false : _ref$disableLookup,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      _ref$List = _ref.List,
      List = _ref$List === void 0 ? DefaultList : _ref$List,
      _ref$Item = _ref.Item,
      Item = _ref$Item === void 0 ? DefaultItem : _ref$Item,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {
    return undefined;
  } : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return undefined;
  } : _ref$onBlur,
      rest = _objectWithoutPropertiesLoose(_ref, ["options", "value", "multiple", "initialOthersOption", "othersLabel", "onChange", "error", "disabled", "disableOptionClearing", "disableLookup", "theme", "List", "Item", "onFocus", "onBlur"]);

  var _useState = useState({
    val: value
  }),
      val = _useState[0].val,
      setVal = _useState[1];

  var _useState2 = useState({
    open: false
  }),
      open = _useState2[0].open,
      setOpen = _useState2[1];

  var _useState3 = useState({
    lookupText: ''
  }),
      lookupText = _useState3[0].lookupText,
      setLookupText = _useState3[1];

  var _useState4 = useState({
    activeIndex: null
  }),
      activeIndex = _useState4[0].activeIndex,
      setActiveIndex = _useState4[1];

  var _useState5 = useState({
    scrollTop: 0
  }),
      scrollTop = _useState5[0].scrollTop,
      setScrollTop = _useState5[1];

  var _useState6 = useState(''),
      othersText = _useState6[0],
      setOthersText = _useState6[1];

  var currentOthersOption = initialOthersOption ? {
    value: othersText ? initialOthersOption.value + ": " + othersText : initialOthersOption.value,
    label: othersText ? initialOthersOption.label + ": " + othersText : initialOthersOption.label
  } : null;
  var containerEl = useRef(null);
  var scrollBoxEl = useRef(null);
  var othersInputRef = useRef(null);
  useEffect(function () {
    setVal({
      val: value
    });
  }, [value]);

  var onChangeInternal = function onChangeInternal(v
  /*: ?ValueType */
  ) {
    setLookupText({
      lookupText: ''
    });
    setVal({
      val: v
    });
    onChange(v);
  };
  /**
   * using useCallback to prevent re-creation on each render
   */


  var handlePopupClose = function handlePopupClose(e) {
    if (containerEl.current && !containerEl.current.contains(e.target)) {
      setLookupText({
        lookupText: ''
      });
      setOpen({
        open: false
      });
    }
  };

  var areOptionsEqual = function areOptionsEqual(o1
  /*: ?OptionType */
  , o2
  /*: ?OptionType */
  ) {
    return o1 && o2 && o1.value === o2.value;
  }; // eslint-disable-next-line no-nested-ternary


  var selectedOptions
  /*: Array<?OptionType> */
  = Array.isArray(val) ? val : multiple && !val ? [] : [val];
  var filteredOptions = options.filter(function (option) {
    return !lookupText || option.label.toUpperCase().includes(lookupText.toUpperCase());
  });
  useEffect(function () {
    setActiveIndex({
      activeIndex: null
    }); // reset index on dropdown toggle
  }, [open]);
  useEffect(function () {
    if (scrollBoxEl && scrollBoxEl.current) {
      scrollBoxEl.current.scrollTop = scrollTop;
    }
  }, [scrollTop]);

  var handleToggleDropdown = function handleToggleDropdown() {
    setLookupText({
      lookupText: ''
    });
    setOpen({
      open: !open
    });
  };

  var handleClearOption = function handleClearOption() {
    onChangeInternal(null);
  };

  var processOptionChange = function processOptionChange(option
  /*: OptionType */
  ) {
    if (multiple) {
      var filtered = selectedOptions.filter(function (el) {
        return !areOptionsEqual(el, option);
      });
      var isOthersClickedOn = currentOthersOption && currentOthersOption.value.startsWith(option.value);

      if (isOthersClickedOn) {
        /**
           * If user clicked on Others, we want to filter it out
           * irrespectively of whether it's On or Off. Read comment below
           */
        filtered = filtered.filter(function (el) {
          return !areOptionsEqual(el, currentOthersOption);
        });
        setOthersText('');
      }
      /* Following implements toggle logic. If option was in list we just
      remove it with filter on previous step. If nothing was removed on
      previous step then it means item was selected and we add
      option to selection list.
       */


      var isNewlySelected = filtered.length === selectedOptions.length;

      if (isNewlySelected) {
        onChangeInternal([].concat(_toConsumableArray(selectedOptions), [option]));
      } else {
        onChangeInternal(filtered);
      }
    } else {
      onChangeInternal(option);
    }
  };

  var handleOptionSelect = function handleOptionSelect(option
  /*: OptionType */
  ) {
    processOptionChange(option);

    if (!multiple) {
      setOpen({
        open: false
      });
    }
  };

  var handleOnTextChange = function handleOnTextChange(v) {
    if (!multiple) {
      setLookupText({
        lookupText: v
      });

      if (v) {
        setOpen({
          open: true
        });
      }
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    // dropdown is open, has items and down or up arrow pressed
    if (open && filteredOptions.length > 0 && [DOWN, UP].includes(e.keyCode)) {
      var index;
      var downDirection = e.keyCode === DOWN;

      if (activeIndex !== null) {
        index = activeIndex;

        if (downDirection) {
          index++;
        } else {
          index--;
        }
      } else {
        index = 0;
      } // make sure it's within boundaries


      index = Math.min(filteredOptions.length - 1, index);
      index = Math.max(0, index);
      setActiveIndex({
        activeIndex: index
      }); // calculate scrollTop so selected item is always in view

      if (scrollBoxEl && scrollBoxEl.current) {
        var itemHeight = scrollBoxEl.current.scrollHeight / filteredOptions.length;
        var currItemOffset = index * itemHeight;
        var visibleItems = scrollBoxEl.current.clientHeight / itemHeight;

        if (currItemOffset < scrollBoxEl.current.scrollTop || currItemOffset + itemHeight > scrollBoxEl.current.scrollTop + visibleItems * itemHeight) {
          if (downDirection) {
            setScrollTop({
              scrollTop: currItemOffset - (visibleItems - 1) * itemHeight
            });
          } else {
            setScrollTop({
              scrollTop: currItemOffset
            });
          }
        }
      }

      e.preventDefault();
      return;
    }

    if (open && e.keyCode === ENTER) {
      if (multiple && activeIndex !== null) {
        setOpen({
          open: false
        });
        processOptionChange(filteredOptions[activeIndex]);
      } else if (activeIndex !== null) {
        onChangeInternal(filteredOptions[activeIndex]);
        setOpen({
          open: false
        });
      }

      e.preventDefault();
      return;
    } // space


    if (multiple && open && activeIndex !== null && e.keyCode === 32) {
      processOptionChange(filteredOptions[activeIndex]);
      e.preventDefault();
      return;
    }

    if (!open && (e.keyCode === DOWN || e.keyCode === UP || e.keyCode === ENTER)) {
      setOpen({
        open: true
      });
      e.preventDefault();
      return;
    }

    if (e.keyCode === ESCAPE) {
      setOpen({
        open: false
      });
    }

    if (e.keyCode === BACKSPACE) {
      if (!lookupText) {
        onChangeInternal(null);
      }
    }
  };

  var isSelected = function isSelected(option
  /*: OptionType */
  ) {
    return selectedOptions.some(function (el) {
      return areOptionsEqual(el, option);
    });
  };

  useEffect(function () {
    var autoFocusOnOthersSelect = function autoFocusOnOthersSelect() {
      var isOthersSelected = isSelected(initialOthersOption);

      if (isOthersSelected && othersInputRef && othersInputRef.current) {
        othersInputRef.current.focus();
      }
    };

    autoFocusOnOthersSelect();
  }, [selectedOptions]);

  var onOthersChange = function onOthersChange(newOthersText) {
    if (!multiple || !currentOthersOption) {
      return;
    }

    var isOthersSelected = isSelected(currentOthersOption);
    if (!isOthersSelected) return;

    if (!newOthersText) {
      setOthersText('');
      var filtered = selectedOptions.filter(function (el) {
        return !areOptionsEqual(el, currentOthersOption);
      });
      onChangeInternal([].concat(_toConsumableArray(filtered), [initialOthersOption]));
      return;
    }

    var selectedOptionsWithoutOthers = selectedOptions.filter(function (el) {
      return !areOptionsEqual(el, currentOthersOption);
    });
    var newOthersOption = {
      value: newOthersText ? initialOthersOption.value + ": " + newOthersText : initialOthersOption.value,
      // eslint-disable-next-line max-len
      label: newOthersText ? initialOthersOption.label + ": " + newOthersText : initialOthersOption.label
    };
    setOthersText(newOthersText);
    onChangeInternal([].concat(_toConsumableArray(selectedOptionsWithoutOthers), [newOthersOption]));
  };

  var isOthersSelected = function isOthersSelected() {
    return selectedOptions.some(function (el) {
      return el && el.value.startsWith(initialOthersOption.value);
    });
  };

  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    ref: containerEl,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    "data-test": "select-main"
  }, rest), /*#__PURE__*/React.createElement(theme.InputContainer, null, multiple ? /*#__PURE__*/React.createElement(MultiInput, {
    open: open,
    error: !!error,
    disabled: disabled,
    options: selectedOptions,
    onToggleDropdown: handleToggleDropdown,
    onKeyDown: handleKeyDown,
    theme: theme.MultiInput,
    onFocus: onFocus,
    onBlur: onBlur
  }) : /*#__PURE__*/React.createElement(Input, {
    open: open,
    error: !!error,
    disabled: disabled,
    disableOptionClearing: disableOptionClearing,
    disableLookup: disableLookup,
    option: selectedOptions && selectedOptions[0],
    lookupText: lookupText,
    onToggleDropdown: handleToggleDropdown,
    onClearOption: handleClearOption,
    onChange: handleOnTextChange,
    onKeyDown: handleKeyDown,
    onFocus: onFocus,
    onBlur: onBlur,
    theme: theme.Input
  })), /*#__PURE__*/React.createElement(Popup, {
    visible: open,
    autoUpwards: true,
    onClose: handlePopupClose,
    theme: theme.Popup
  }, /*#__PURE__*/React.createElement(theme.ScrollBox, {
    ref: scrollBoxEl,
    "data-test": "select-scrollbox"
  }, /*#__PURE__*/React.createElement(List, {
    theme: theme.List
  }, filteredOptions.map(function (option, idx) {
    return /*#__PURE__*/React.createElement(Item // eslint-disable-next-line
    , {
      key: idx,
      option: option,
      onSelect: handleOptionSelect,
      active: idx === activeIndex,
      selected: isSelected(option),
      lookupText: lookupText,
      checkbox: multiple,
      onMouseEnter: function onMouseEnter() {
        return setActiveIndex({
          activeIndex: idx
        });
      },
      theme: theme.Item
    });
  }), multiple && currentOthersOption && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Item, {
    key: 0.999,
    option: initialOthersOption,
    onSelect: handleOptionSelect,
    active: activeIndex === 0.999,
    selected: isSelected(currentOthersOption),
    lookupText: lookupText,
    checkbox: multiple,
    onMouseEnter: function onMouseEnter() {
      setActiveIndex({
        activeIndex: 0.999
      });
    },
    theme: theme.Item
  }), isOthersSelected() ? /*#__PURE__*/React.createElement(theme.OthersInputContainer, null, /*#__PURE__*/React.createElement(FormElement, {
    label: othersLabel,
    hasValue: !!othersText,
    theme: theme.OthersInputFormElement
  }, /*#__PURE__*/React.createElement(InputMolecule, {
    ref: othersInputRef,
    value: othersText,
    onChange: function onChange(othersVal) {
      return onOthersChange(othersVal);
    },
    theme: theme.OthersInput
  }))) : null)))));
};

Select.displayName = 'Select';
export default Select;